import React from "react";
import { useMediaQuery } from "react-responsive";

type StatBoxProps = {
  color: string;
  title: string;
  children: React.ReactNode;
  darkMode?: boolean;
};

const StatBox: React.FC<StatBoxProps> = ({
  color,
  title,
  children,
  darkMode = false,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const borderRadius = isMobile ? 16 : 28;
  const boxHeight = isMobile ? 28 : 44;
  const minWidth = isMobile ? 80 : 120;
  const maxWidth = isMobile ? 110 : 160;
  const minContentHeight = isMobile ? 48 : 80;
  const fontSize = isMobile ? "0.875rem" : "1.125rem";
  return (
    <div
      className="flex flex-col items-center"
      style={{ minWidth, maxWidth, width: "100%" }}
    >
      {/* Top colored border with rounded top */}
      <div
        style={{
          background: color,
          borderTopLeftRadius: borderRadius,
          borderTopRightRadius: borderRadius,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          height: boxHeight,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          position: "relative",
        }}
      >
        <span
          className={`font-bold w-full text-center ${
            darkMode ? "text-gray-800" : "text-gray-100"
          }`}
          style={{
            fontFamily: "Feather Bold",
            fontSize,
          }}
        >
          {title}
        </span>
        {/* SVG curve for left */}
        <svg
          viewBox="0 0 40 44"
          width={isMobile ? 20 : 32}
          height={boxHeight}
          style={{
            position: "absolute",
            left: 0,
            bottom: -(boxHeight - 5),
            zIndex: 2,
            pointerEvents: "none",
          }}
        >
          <path d="M0,0 L40,0 Q0,0 0,44 Z" fill={color} />
        </svg>
        {/* SVG curve for right */}
        <svg
          viewBox="0 0 40 44"
          width={isMobile ? 20 : 32}
          height={boxHeight}
          style={{
            position: "absolute",
            right: 0,
            bottom: -(boxHeight - 5),
            zIndex: 2,
            transform: "scaleX(-1)",
            pointerEvents: "none",
          }}
        >
          <path d="M0,0 L40,0 Q0,0 0,44 Z" fill={color} />
        </svg>
      </div>
      {/* White box with rounded bottom and thin border */}
      <div
        style={{
          borderLeft: `3px solid ${color}`,
          borderRight: `3px solid ${color}`,
          borderBottom: `3px solid ${color}`,
          borderBottomLeftRadius: borderRadius,
          borderBottomRightRadius: borderRadius,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          background: darkMode ? "#1e293b" : "#fff",
          width: "100%",
          minHeight: minContentHeight,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: color,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default StatBox;
